<template>
  <v-app class="homebg">
    <AppHeader />
<!-- <appheadersample/> -->
    <router-view />
    
    <AppFooter />
  </v-app>
</template>

<script>
import AppHeader from "./components/common/AppHeader";
// import appheadersample from "./components/common/appheadersample";
import AppFooter from "./components/common/AppFooter";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    // appheadersample
  },
  data: () => ({
    //
  })
};
</script>


<style>
.homebg{
  background-image: url("https://picsum.photos/200/300??random");
  background-repeat: no-repeat;
  background-size: cover;
}
.fontst{
  font-size:16px;
}
</style>